import ChatGPTService from "@/services/ChatGPTService";

export const chatGPT = {
  namespaced: true,
  state: {
    chatGPT: {},
  },
  actions: {
    getChat({ commit }, payload) {
      return ChatGPTService.GetChat(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default chatGPT;
